import React from "react";

import Contact from "../../../template/Contact";

export default () => {
  return (
    <Contact
      title="Seja Um Vonluntário"
      subtitle="Nos envie uma mensagem que entraremos em contato com você para conversarmos sobre serviços voluntários"
      message={"Olá! \nGostaria de ajudar..."}
      isVolunteer
    />
  );
};
